<template>
  <v-dialog persistent v-model="dialog" :width="400">
    <v-container class="ma-0 pa-0" style="overflow: hidden;">
      <v-card class="pa-2 ma-0">
        <v-row class="pb-1" align="center" justify="center">
          <v-row class="pa-0 ma-0 ma-5" justify="center" align="center">
            <v-select :items="disc_Add_For_List" v-model="disc_Add_For" label="Тип" dense></v-select>
            <v-select :items="disc_Add_Type_List" v-model="disc_Add_Type" label="Относно" dense></v-select>

            <v-row class="ma-0 pa-0" align="center">
              <v-text-field label="Сума" dense></v-text-field>
              <v-tooltip bottom>
                <template v-slot:activator="on">
                  <v-checkbox v-on="on" dense label="%" v-model="disc_Percent"></v-checkbox>
                </template>
                <span>Остъпка - %</span>
              </v-tooltip>
            </v-row>

            <v-btn small block outlined @click="applyDiscAdd">Приложи</v-btn>
          </v-row>
        </v-row>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import Const from "../constants";
export default {
  props: {},
  data() {
    return {
      dialog: true,
      disc_Add_For_List: ["Отстъпка", "Надбавка"],
      disc_Add_For: "Отстъпка",
      disc_Add_Type_List: ["Последен артикул", "Целия бон"],
      disc_Add_Type: "Последен артикул",
      disc_Percent: true
    };
  },
  computed: {},
  methods: {
    applyDiscAdd() {
      this.fp.exitMode(Const.Modes.DiscountOrAddition);
    }
  },
  mounted() {}
};
</script>